// extracted by mini-css-extract-plugin
module.exports = {"heading":"HeadingFooter_heading__MUUJa"};